/**
 * The words a reader sees for the room's internal names.
 *
 * The seats are called profiler, cartographer, skeptic inside the room. On
 * screen they are what they do: "the page reader", "the sorter", "the fact
 * checker". One list, so every place says the same thing.
 *
 * Pure, so jest can pin it.
 */

/** What each seat does, as a reader would say it. */
export const SEAT_ROLE: Record<string, string> = {
  cartographer: 'the sorter',
  skeptic: 'the fact checker',
  profiler: 'the page reader',
  competitor_miner: 'the company finder',
  customer_voice: 'the review reader',
  demand_analyst: 'the search analyst',
  strategist: 'the planner',
  ideator: 'the idea writer',
  observer: 'the note taker',
  director: 'the planner',
  human: 'you',
};

/** A seat by its archetype or its name ("Skeptic 4", "competitor_miner"), in
 *  plain words. Something unknown is shown as written, without underscores. */
export function seatRole(who: string | null | undefined): string {
  if (!who) return '';
  const key = who
    .trim()
    .toLowerCase()
    .replace(/[\s_]*\d+$/, '')
    .replace(/\s+/g, '_');
  return SEAT_ROLE[key] ?? who.replace(/_/g, ' ');
}

/** The same, starting a sentence. */
export function SeatRole(who: string | null | undefined): string {
  const s = seatRole(who);
  return s.charAt(0).toUpperCase() + s.slice(1);
}
